export default function sanitizeUrl(unsanitized: string) {
  return encodeURIComponent(
    unsanitized
      .toLowerCase()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/gi, "-")
  )
}
